import { render, staticRenderFns } from "./ProductSizes.vue?vue&type=template&id=3dd2bfca&scoped=true&"
import script from "./ProductSizes.vue?vue&type=script&lang=js&"
export * from "./ProductSizes.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizes.vue?vue&type=style&index=0&id=3dd2bfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2bfca",
  null
  
)

export default component.exports